// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2aPZg","header":"ReportDetails_header__1i15V","title":"ReportDetails_title__2a87Q","left":"ReportDetails_left__1fv6p"};